export enum EntityModelConfiguration {
  Retag = 0,
  RecallAssignedTask = 1,
  RecallValidatedTask = 2
}
